
import {useState} from 'react';
import postAPI from '../functions/API/postAPI.js'
import { toast } from '../lib/toast.js';

export default function NewCategoryForm({setVisible, refresh, refreshValue, categoryData}) {

    const [newCategory, setNewCategory] = useState({
        name: categoryData ? categoryData.name : "",
        friendlyname: categoryData ? categoryData.friendlyname : "",
        active: categoryData ? categoryData.active : true,
    })

    async function createNewCategory(){
        const body = {name: newCategory.name, friendlyname: newCategory.friendlyname, active: newCategory.active}
        const NewCategoryResponse = await postAPI('category', body);
        if(NewCategoryResponse.response.ok){
            refresh(refreshValue+1);
            toast.success('Category created successfully.');
            setVisible(false);
        }else{
            toast.error('Sorry an error occurred. Try again later.');
        }        
    }

    async function updateCategory(){
        const body = {id: categoryData.id, name: newCategory.name, friendlyname: newCategory.friendlyname, active: newCategory.active}
        const UpdatedCategoryResponse = await postAPI('category/update', body);
        if(UpdatedCategoryResponse.response.ok){
            refresh(refreshValue+1);
            toast.success('Category updated successfully.');
            setVisible(false);
        }else{
            toast.error('Sorry an error occurred. Try again later.');
        }        
    }

    function handleChange (event) {
        let statechange = event.target.name;
        let value = event.target.value;
        setNewCategory({...newCategory, [statechange]: value})
    }

    return (
        <form>
            <div className="space-y-4">
                <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900 dark:text-white">{categoryData ? "Update repair category" : "Create new repair category"}</h2>
                    <p className="mt-1 text-sm leading-6 text-gray-600 dark:text-gray-400 dark:text-gray-400">Repair categories help customers select repair defintions</p>
                </div>

                <div className="grid grid-cols-1 gap-x-6 gap-y-6">
                    <div className="sm:col-span-1">
                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900 dark:text-white">
                            Category name
                        </label>
                        <div className="">
                            <input
                            defaultValue={newCategory ? newCategory.name : ""}
                            required
                            type="text"
                            onChange={handleChange}
                            name="name"
                            id="name"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-white dark:bg-zinc-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-zinc-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                            />
                        </div>
                    </div>
                    <div className="sm:col-span-1">
                        <label htmlFor="friendlyname" className="block text-sm font-medium leading-6 text-gray-900 dark:text-white">
                            Friendly name
                        </label>
                        <div className="">
                            <input
                            required
                            value={newCategory ? newCategory.friendlyname : "d"}
                            type="text"
                            onChange={handleChange}
                            name="friendlyname"
                            id="friendlyname"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-white dark:bg-zinc-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-zinc-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 flex items-center justify-start gap-x-6">
                <button
                type="button"
                onClick={
                    categoryData ? 
                        ()=>{updateCategory()} :
                        ()=>{createNewCategory()}
                    }
                className="rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                >
                    {categoryData ? "Update" : "Create"}
                </button>
                <button type="button" onClick={()=>{setVisible(false)}} className="text-sm font-semibold leading-6 text-gray-900 dark:text-white">
                Cancel
                </button>
            </div>
        </form>
    )
}
